import { render, staticRenderFns } from "./list-page.vue?vue&type=template&id=3588b7b0&scoped=true&"
import script from "./list-page.vue?vue&type=script&lang=js&"
export * from "./list-page.vue?vue&type=script&lang=js&"
import style0 from "./list-page.vue?vue&type=style&index=0&id=3588b7b0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588b7b0",
  null
  
)

export default component.exports